import routes from '@/modules/cycle/cycle-routes';
import store from '@/modules/cycle/cycle-store';

export default {
  routes,
  store,
};
